// var video_wrapper = jQuery('.youtube-video-place');
// //  Check to see if youtube wrapper exists
// if(video_wrapper.length){
// // If user clicks on the video wrapper load the video.
// jQuery('.play-youtube-video').on('click', function(){
// /* Dynamically inject the iframe on demand of the user.
//  Pull the youtube url from the data attribute on the wrapper element. */
// video_wrapper.html('<iframe allowfullscreen frameborder="0" width=”854″ height=”480″  class="embed-responsive-item" src="' + video_wrapper.data('yt-url') + '"></iframe>');
// });
// }

jQuery('.play-youtube-video').on('click', function(){
    var video_wrapper = jQuery(this).closest('.youtube-video-place');
  /* Dynamically inject the iframe on demand of the user.
   Pull the youtube url from the data attribute on the wrapper element. */
   video_wrapper.html('<iframe allowfullscreen frameborder="0" width=”854″ height=”480″  class="embed-responsive-item" src="' + video_wrapper.data('yt-url') + '"></iframe>');
});